(function (angular) {
  "use strict";

  angular
    .module("Toyota.Directives")
    .directive("tyScrollbarWidthCssCustomProp", [
      function () {
        function updateScrollbarWidth() {
          const scrollbarWidth =
            window.innerWidth - document.documentElement.offsetWidth;
          document.documentElement.style.setProperty(
            "--ty-scrollbar-width",
            scrollbarWidth + "px"
          );
        }

        return {
          restrict: "E",
          scope: false,
          link: function () {
            updateScrollbarWidth();
            window.addEventListener("resize", updateScrollbarWidth);
          },
        };
      },
    ]);
})(window.angular);
